module.exports = __webpack_public_path__ + "static/gray_default-3a2a2d16197597b23b68584e17940dab.jpg";